<template>
  <div class="new-oil-recharge-body">
    <div class="new-oil-recharge-nav">
      <navbar title="确认信息" :lefticonshow="true" :lefticonwidth="9" :lefticonheight='16' :lefticon="newoilcardbackicon" @goback="goBack" />
    </div>
    <div class="new-oil-card-div">
      <div class="oli-card-item">
        <img class="oli-card-bg" :src="oil_type == 'sinopec' ?chinasinopecbgicon: chinapetroleumbgicon " alt="">
        <div class="oli-card-con">
          <div class="card-first-div">
            <div>
              <img class="oli-card-logo" :src="oil_type == 'sinopec' ? chinasinopeclogo : chinapetroleumlogo" alt="">
              <span class="oli-card-name">{{oil_type == "sinopec" ?'中国石化加油卡':'中国石油加油卡'}}</span>
            </div>
            <div>
              <span class="oli-card-nickname">{{remark}}</span>
            </div>
          </div>
          <div class="card-second-div">
            <div class="oil-tag">Card number</div>
            <div class="oil-number">{{HandlecardNumber(gas_card_number)}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="card-confirm-div">
      <div class="card-member-info-title">请确认您的信息</div>
      <div class="card-member-info-div">
        <div class="input-item">
          <span class="input-label">姓名</span>
          <span class="input-content">
            <common-input :value.sync="name" :clearshow="true" @input="handleNameInput"></common-input>
          </span>
        </div>
        <div class="input-item">
          <span class="input-label">证件号码</span>
          <span class="input-content">
            <common-input :value.sync="id_card_number" :maxLength="18" :clearshow="true" @input="handleIdCardNumberInput"></common-input>
          </span>
        </div>
      </div>
    </div>
    <div class="card-confirm-description">
      <p>注：</p>
      <p>1、请确保您的油卡身份信息与此处绑定的信息一致，否则将会充值失败；</p>
      <p>2、若信息不正确请及时修改，避免影响充值。</p>
    </div>
    <div class="new-oil-recharge-bottom">
      <div class="recharge-btn" @click="goPay" :style="{'opacity': id_card_number && name ? 1 : 0.4}"><span>{{sumbit_button_text}}</span></div>
    </div>

    <centerrscreenloading :loading="page_loading" />
  </div>
</template>

<script>
  import navbar from '../components/nav-bar.vue'
  import centerrscreenloading from '../components/centerrscreen-loading.vue'
  import commonInput from '../components/common-input.vue'
  import { checkThirdrechargeMemberCardInfo, fixThirdrechargeMemberCardInfo } from '../api/index'
  import { Toast } from 'vant'
  export default {
    components: { navbar, centerrscreenloading, commonInput },
    data () {
      return {
        newoilcardbackicon: require('@/assets/recharge/new-oilcard-back-icon.png'),
        chinapetroleumbgicon: require('@/assets/recharge/china-petroleum-bg-icon.png'),
        chinapetroleumlogo: require('@/assets/recharge/china-petroleum-logo.png'),
        chinasinopecbgicon: require('@/assets/recharge/china-sinopec-bg-icon.png'),
        chinasinopeclogo: require('@/assets/recharge/china-sinopec-logo.png'),
        page_loading: true,
        remark: '',
        id_card_number: '',
        name: '',
        oil_type: '',
        old_name: '', // 接口返回的油卡姓名
        old_id_card_number: '', // 接口返回的油卡证件号码
        sumbit_button_text: '提交去支付'
      }
    },
    async created () {
      this.oil_type = this.$route.query.oil_type
      this.gas_card_number = this.$route.query.charge_account
      await checkThirdrechargeMemberCardInfo({ gas_card_number: this.gas_card_number }).then((res) => {
        this.page_loading = false
        this.remark = res.remark
        this.id_card_number = res.id_card_number
        this.name = res.name
        this.old_name = res.name
        this.old_id_card_number = res.id_card_number
      })
    },
    methods: {
      handleNameInput () {
        if (this.old_name !== this.name && this.old_name) {
          this.sumbit_button_text = '提交并保存去支付'
        }
      },
      handleIdCardNumberInput () {
        if (this.old_id_card_number !== this.id_card_number && this.old_id_card_number) {
          this.sumbit_button_text = '提交并保存去支付'
        }
      },
      HandlecardNumber (number) {
        let new_number = ''
        for (let index in number) {
          new_number += number[index]
          if (index % 4 == 3) {
            new_number += ' '
          }
        }
        return new_number
      },
      goPay () {
        if(!this.name || !this.id_card_number){
          return
        }
        this.page_loading = true
        fixThirdrechargeMemberCardInfo({
          "gasCardNo": this.gas_card_number, //类型：String  必有字段  备注：油卡账号
          "operator": this.oil_type, //类型：String  必有字段  备注：油卡类型（中石油cnpc，中石化sinopec）
          "id_card_number": this.id_card_number, //类型：String  必有字段  备注：持卡人省份证号码
          "name": this.name //类型：String  必有字段  备注：持卡人姓名
        }).then(() => {
          this.page_loading = false
          this.$router.push({
            path: "/new-oli/orderConfirm",
            query: {
              "charge_id": this.$route.query.charge_id, //类型：String  必有字段  备注：charge_id
              "channel_id": this.$route.query.channel_id, //类型：String  必有字段  备注：channel_id
              "goods_id": this.$route.query.goods_id, //类型：String  必有字段  备注：面额id
              "charge_account": this.$route.query.charge_account, //类型：String  必有字段  备注：油卡账号
              "charge_amount": this.$route.query.charge_amount, //类型：String  必有字段  备注：充值金额
              oil_type: this.oil_type,
              item_id: this.$route.query.item_id,
              "id_card_number": this.id_card_number, //类型：String  必有字段  备注：持卡人省份证号码
              "name": this.name //类型：String  必有字段  备注：持卡人姓名
            }
          })
        }).catch((err) => {
          const keys = Object.keys(err)
          Toast(err[keys[0]][0])
          this.page_loading = false
        })

      },
      goPage (path) {
        this.$router.push({
          path
        })
      },
      goBack () {
        if (this.$route.query.card_id) {
          this.$router.go(-2)
        } else {
          this.$router.go(-1)
        }
      }
    }
  }
</script>
<style lang="less">
  .new-oil-recharge-body {
    .oil-pup-div {
      .oil-pup-con {
        top: 320px !important;
        transform: translateX(-50%) !important;
      }
    }
  }
</style>
<style lang="less" scoped>
  .new-oil-recharge-body {
    padding-top: 88px;
    min-height: calc(100vh - 88px);
    background: linear-gradient(180deg, #FFFFFF 0%, #F5F5F5 100%);

    .new-oil-recharge-nav {
      padding-top: 44px;
      position: fixed;
      top: 0;
      left: 0;
      z-index: 9;
      background: #FFFFFF;
    }

    .new-oil-card-div {
      margin-top: 16px;
      height: 166px;
      padding: 0 16px;
      background: #FFFFFF;

      .oli-card-item {
        height: 166px;
        position: relative;


        .oli-card-bg {
          position: absolute;
          left: 0;
          top: 0;
          height: 166px;
          width: 100%;
          z-index: 1;
        }

        .oli-card-con {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          z-index: 2;

          .card-first-div {
            padding: 18px 0 40px 9px;
            display: flex;
            justify-content: space-between;
            height: 26px;
            width: calc(100% - 18px);

            .oli-card-logo {
              width: 25px;
              height: 26px;
              margin-right: 9px;
            }

            .oli-card-name {
              font-size: 14px;
              font-weight: 500;
              text-align: left;
              color: #ffffff;
              line-height: 20px;
              letter-spacing: 1.1px;
              text-shadow: 1px 0px 0px 0px #f5621c;
              margin-top: 3px;
              display: inline-block;
              vertical-align: top;
            }

            .oli-card-nickname {
              display: inline-block;
              vertical-align: top;
              margin-top: 5px;
              font-size: 12px;
              font-weight: 400;
              text-align: right;
              color: #ffffff;
              line-height: 17px;
              margin-right: 12px;
            }

            .oli-card-setting {
              position: absolute;
              display: inline-block;
              top: 24px;
              right: 16px;
              width: 16px;
              height: 16px;

              img {
                width: 16px;
                height: 16px;
              }

            }
          }

          .card-second-div {
            padding-left: 9px;

            .oil-tag {
              opacity: 0.6;
              font-size: 10px;
              font-weight: 400;
              text-align: left;
              color: #ffffff;
              line-height: 12px;
              letter-spacing: 0.33px;
              margin-bottom: 3px;
            }

            .oil-number {
              font-size: 18px;
              font-weight: 600;
              text-align: left;
              color: #ffffff;
              line-height: 25px;
              letter-spacing: 0.59px;
            }
          }
        }
      }

      .new-oil-indicator {
        height: 3px;
        font-size: 0;
        display: flex;
        position: relative;
        left: 50%;
        transform: translateX(-50%);
        white-space: nowrap;
        overflow-x: auto;
        width: calc(100vw - 32px);
        margin-top: 5px;
        justify-content: center;

        span {
          display: inline-block;
          flex: 1;
          max-width: 36px;
          height: 3px;
          background: #eaeaea;
          border-radius: 2px;
        }

        .indicator-activate {
          background: linear-gradient(135deg, #ff792d, #f8541a);
        }

      }
    }

    .card-confirm-div {
      background: #FFFFFF;

      .card-member-info-title {
        padding: 12px 16px;
        height: 22px;
        font-size: 16px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #333333;
        line-height: 22px;
      }

      .card-member-info-div {
        .input-item {
          height: 51px;
          margin: 0 16px;
          display: flex;
          align-items: center;

          &:nth-child(1) {
            border-bottom: 1px solid #F5F5F5;
          }

          span {
            &:nth-child(1) {
              white-space: nowrap;
              margin-right: 30px;
              height: 22px;
              font-size: 15px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #323232;
              line-height: 22px;
            }
          }

          .input-content {
            /deep/.common-input {
              padding-left: 2px;
            }
          }
        }
      }
    }

    .card-confirm-description {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #F55019;
      line-height: 20px;
      padding: 12px 16px 0;
    }

    .new-oil-recharge-bottom {
      width: 100vw;
      padding-top: calc(100vh - 88px - 182px - 149px - 92px - 45px - 34px);

      .recharge-btn {
        width: calc(100% - 60px);
        margin: 0 30px;
        height: 25px;
        background: linear-gradient(135deg, #fa770d, #f44d19);
        border-radius: 25px;
        text-align: center;
        padding: 10px 0;

        span {
          font-size: 18px;
          font-weight: 500;
          text-align: center;
          color: #ffffff;
          line-height: 25px;
        }
      }

    }

    .bm34 {
      bottom: 67px;
    }
  }
</style>